module.exports = __webpack_public_path__ + "src/assets/img/posduck.55e34f47.png";